export default __webpack_public_path__ + "secondCarouselItem.143ab0e4df7a1be662beebe6949b987d.png";